import { newE2EPage } from "@stencil/core/testing";
import { GuidedTourData } from "./types";
import {
    localStorageNameAutostart,
    localStorageNameCompleted,
} from "./constants";

const testData: GuidedTourData = {
    autoStart: true,
    intro: {
        title: "Intro Title",
        body: "Intro Description",
    },
    steps: [
        {
            title: "Step 1 Title",
            body: "Step 1 Description",
        },
        {
            title: "Step 2 Title",
            body: "Step 2 Description",
        },
    ],
};

describe("guided-tour", () => {
    beforeEach(() => {
        localStorage.removeItem(localStorageNameAutostart);
        localStorage.removeItem(localStorageNameCompleted);
    });

    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-guided-tour></ux-guided-tour>`);
        const el = await page.find("ux-guided-tour");
        el.setProperty("data", testData);
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
    });

    it("should emit uxGuidedTourChange when activated and on tour navigation", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-guided-tour></ux-guided-tour>`);
        const changeEvent = await page.spyOnEvent("uxGuidedTourChange");
        const el = await page.find("ux-guided-tour");
        el.setProperty("data", testData);
        await page.waitForChanges();

        expect(changeEvent).toHaveReceivedEventDetail({
            prevStep: null,
            nextStep: testData.intro,
        });

        await el.callMethod("nextStep");
        expect(changeEvent).toHaveReceivedEventDetail({
            prevStep: testData.intro,
            nextStep: testData.steps[0],
        });

        await el.callMethod("nextStep");
        expect(changeEvent).toHaveReceivedEventDetail({
            prevStep: testData.steps[0],
            nextStep: testData.steps[1],
        });

        await el.callMethod("prevStep");
        expect(changeEvent).toHaveReceivedEventDetail({
            prevStep: testData.steps[1],
            nextStep: testData.steps[0],
        });
    });
});
